

import { EmailSettingsType } from "../../types/EmailSetingsType";
import { delEmptyBody, get, post, put } from "../../utils/axios-config";
import { EmailSettings } from "../../utils/constants";

export const createEmailSettings  = async (data: EmailSettingsType) => {
  return await post<EmailSettingsType, string>(EmailSettings, data);
};

export const updateEmailSettings  = async (data: EmailSettingsType) => {
  return await put<EmailSettingsType, string>(EmailSettings, data);
};

export const getEmailSettings  = async () => {
  return await get<EmailSettingsType>(EmailSettings);
};

export const deleteEmailSettings  = async (id: string) => {
  return await delEmptyBody<any>(`${EmailSettings}/${id}`);

};
